import { gql } from "@apollo/client";

export const FIND_UPLOAD_LINKS = gql`
  query FindUploadLinks($opportunityAssetId: ID, $taskId: ID, $includeDeleted: Boolean) {
    findUploadLinks(opportunityAssetId: $opportunityAssetId, taskId: $taskId, includeDeleted: $includeDeleted) {
      _id
      userId {
        _id
        firstName
        lastName
        email
      }
      label
      linkSlug
      status
      expiresAt
      createdAt
      accessEmails
      meta {
        isDeleted
      }
      opportunityAsset {
        _id
        assetName
        friendlyId
      }
      task {
        _id
        key
        summary
      }
    }
  }
`;

export const FIND_UPLOAD_LINKS_SERVER_SIDE = gql`
  query FindUploadLinksServerSide($input: ServerQueryInput, $includeDeleted: Boolean) {
    findUploadLinksServerSide(input: $input, includeDeleted: $includeDeleted) {
      uploadLinks {
        _id
        userId {
          _id
          firstName
          lastName
          email
        }
        label
        linkSlug
        status
        expiresAt
        createdAt
        accessEmails
        submitterCount
        fileCount
        meta {
          isDeleted
        }
        opportunityAsset {
          _id
          assetName
          friendlyId
        }
        task {
          _id
          key
          summary
        }
      }
      pageInfo {
        currentPage
        pageSize
        totalDocuments
        totalPages
      }
    }
  }
`;

export const GET_UPLOAD_LINK_FILE_COUNT = gql`
  query GetUploadLinkFileCount($linkId: ID!) {
    getUploadLinkFileCount(linkId: $linkId)
  }
`;
